import { render, staticRenderFns } from "./BaitulmalNew.vue?vue&type=template&id=7041a7bc"
import script from "./BaitulmalNew.vue?vue&type=script&lang=js"
export * from "./BaitulmalNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports